import '../../pages/JoinPage.css';

import React, { useState } from 'react';

import { useNavigate } from 'react-router-dom';

import Input from '../../components/common/Input';
import PomPom from '../../components/common/PomPom/PomPom';
import { useDemoStore } from '../store/DemoStoreContext';

/**
 * Pre-filled Join page. Code + password are read-only; coach name is editable
 * and persists via the demo store overlay (localStorage).
 */
const DemoJoinPage: React.FC = () => {
  const navigate = useNavigate();
  const { tryoutMeta, coach, setCoachName } = useDemoStore();
  const logo = `${process.env.PUBLIC_URL}/logo.svg`;

  const [nameDraft, setNameDraft] = useState(coach.name);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    const trimmed = nameDraft.trim();
    if (trimmed.length > 0 && trimmed !== coach.name) {
      setCoachName(trimmed);
    }
    navigate('/demo/tryout');
  };

  return (
    <div className="join-page">
      <div className="join-gutter-pompoms" aria-hidden="true">
        <PomPom size="xlarge" color="pink" className="join-gutter-pompom join-gutter-pompom-right-top" />
        <PomPom size="large" color="teal" className="join-gutter-pompom join-gutter-pompom-left-mid" />
        <PomPom size="xlarge" color="teal" className="join-gutter-pompom join-gutter-pompom-right-bottom" />
        <PomPom size="medium" color="pink" className="join-gutter-pompom join-gutter-pompom-left-bottom" />
        <PomPom size="large" color="pink" className="join-gutter-pompom join-gutter-pompom-right-edge-top" />
        <PomPom size="large" color="teal" className="join-gutter-pompom join-gutter-pompom-left-edge-top" />
        <PomPom size="xlarge" color="teal" className="join-gutter-pompom join-gutter-pompom-right-edge-bottom" />
        <PomPom size="medium" color="pink" className="join-gutter-pompom join-gutter-pompom-left-edge-bottom" />
      </div>
      <div className="join-hero">
        <PomPom size="medium" color="pink" className="join-hero-pompom join-hero-pompom-tr" />
        <PomPom size="small" color="teal" className="join-hero-pompom join-hero-pompom-bl" />
        <div className="join-hero-header-row">
          <h1 className="join-hero-title">
            Join<br />
            <span className="join-hero-accent">tryout</span>
          </h1>
          <img src={logo} alt="CheerEval" className="join-logo" />
        </div>
        <p className="join-hero-sub">In the demo tryout, you'll see how the app works as a scoring coach.</p>
        <p className="join-hero-sub">Coaches join on the web, no app needed.</p>
      </div>

      <div className="join-card">
        <form className="join-form" onSubmit={handleSubmit}>
          <Input
            type="text"
            value={tryoutMeta.code}
            onChange={() => undefined}
            label="Tryout Code"
            disabled
          />
          <Input
            type="text"
            value={tryoutMeta.password}
            onChange={() => undefined}
            label="Tryout Password"
            disabled
          />
          <Input
            type="text"
            value={nameDraft}
            onChange={(e) => setNameDraft(e.target.value)}
            label="Your Name"
            required
          />
          <button type="submit" className="join-btn-submit">Join Demo Tryout</button>
          <button type="button" className="join-link-back" onClick={() => navigate('/')}>
          ← Back to home
          </button>
        </form>
      </div>
    </div>
  );
};

export default DemoJoinPage;
